import { httpClient } from '@/services/httpClient';

/**
 * What the working pages have to work on for the current tenant (insight-core
 * GET /data/lines-status): `{ lines, statements, reading, failed }` - statement lines
 * captured, statements they came from, files still being read, files whose lines failed.
 * See docs/plans/live-working-layer.md §2.19.
 */
const getLinesStatus = async () => {
    const response = await httpClient.get('/api/v1/data/lines-status')

    return response.data
}

export { getLinesStatus }

/**
 * The current tenant's analysis - the snapshot dashboards, reports and Cube read:
 * `{ built_at, behind, answers_changed, statements_changed, rates_changed }`. Counts are
 * null when it has never been built.
 */
const getAnalysisStatus = async () => {
    const response = await httpClient.get('/api/v1/data/analysis-status')

    return response.data
}

/** Build analysis for the current tenant now. Analyst and up. */
const buildAnalysis = async () => {
    const response = await httpClient.post('/api/v1/data/materialize')

    return response.data
}

export { getAnalysisStatus, buildAnalysis }
